export default __webpack_public_path__ + "static/media/home_bg.c3279765.jpg";